import type { WhatsNewLocale } from "./types";

// Exported because the LibertyFi/whats-new repo also hosts small remote
// config files consumed elsewhere in the app (e.g. whitelist/SCORM.json).
// Overridable for local testing against a fork/branch (raw.githubusercontent
// works too and skips jsDelivr's cache) via .env.local:
//   VITE_WHATS_NEW_CDN_BASE_URL=https://raw.githubusercontent.com/<user>/whats-new/<branch>
export const CDN_BASE_URL =
  import.meta.env.VITE_WHATS_NEW_CDN_BASE_URL ??
  "https://cdn.jsdelivr.net/gh/LibertyFi/whats-new@main";

export const WHATS_NEW_INDEX_URL = `${CDN_BASE_URL}/index.json`;

export const DEFAULT_LOCALE: WhatsNewLocale = "en";
const SUPPORTED_LOCALES = new Set<WhatsNewLocale>(["en", "fr"]);

const padId = (id: number) => String(id).padStart(4, "0");

export const entryMarkdownUrl = (
  id: number,
  locale: WhatsNewLocale
): string => `${CDN_BASE_URL}/entries/${locale}/${padId(id)}.md`;

export const resolveLocale = (
  raw: string | undefined
): WhatsNewLocale => {
  const base = (raw ?? "").toLowerCase().split("-")[0] as WhatsNewLocale;
  return SUPPORTED_LOCALES.has(base) ? base : DEFAULT_LOCALE;
};

export const LAST_SEEN_STORAGE_KEY = "libertify.whatsNew.lastSeenId";
